








import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import {
  WebSocketCallMessageTypes,
  VideoCallDeniedReasonCode
} from '@/websocket/receivers/call'
import WebRTCProvider, { WebRTC } from '@/webrtc'
import WebSocketProvider from '@/websocket'
import { WebSocketMessageMode } from '@/websocket/constants'
import { WebSocketClientInterface } from '@/websocket/types'
import { WebSocketEventTypes } from '@/websocket/constants'
import { FromUser } from '@/websocket/receivers/call/receiveMessages'
import { Occupation } from '@/types/user'

@Component
export default class VideoCallReceive extends Vue {
  @Prop(String) roomId!: string
  @Prop(String) pin!: string
  @Prop(String) secret!: string
  @Prop({ default: false }) videoEnable!: boolean
  @Prop() fromUser!: FromUser
  @Prop() fromOccupation!: Occupation

  $store!: ExStore
  webSocket!: WebSocketClientInterface
  webrtc: WebRTC | null = null

  get user() {
    return this.$store.getters['user/userInfo']
  }

  get isRelative() {
    return this.user.isPatientRelative
  }

  get routePrefix() {
    return this.isRelative ? 'Relative' : 'Patient'
  }

  get isCalling() {
    return this.$store.getters['videoCallRoom/isCalling']
  }

  async created() {
    await this.checkIsValidLogin()

    this.$store.dispatch('videoCallRoom/setInCallWebView')

    this.webSocket = WebSocketProvider.createConnection()

    if (this.webSocket.readyState === WebSocket.OPEN) {
      this.waitingVideoRoomReady()
    } else {
      this.webSocket.addListener(WebSocketEventTypes.OPEN, (event: Event) => {
        this.waitingVideoRoomReady()
      })
    }
    this.$postMessage.addEventListener('activateApp', () => {
      this.webSocket = WebSocketProvider.createConnection()
    })
  }

  async checkIsValidLogin() {
    try {
      await this.$api.user.fetch()
    } catch (e) {
      const name = this.user.isPatient ? 'PatientLogin' : 'Login'
      this.$router.replace({ name })
    }
  }

  waitingVideoRoomReady() {
    if (this.user.isPatient || this.user.isPatientRelative)
      this.$router.push({ name: `${this.routePrefix}Call` })
    const unsubscribe = this.$store.subscribe(({ type, payload }) => {
      if (type === 'videoCallRoom/setVideoRoomReady' && payload) {
        console.log('Before callAccept()')
        this.callAccept()
        unsubscribe()
      }
    })
  }

  async callAccept() {
    console.log('INN callAccept()')
    /*
    if (!this.roomId || !this.pin || !this.secret) {
      this.$router.replace({ name: 'Home' })
    }
    */
    // 以下のように変更 必要なデータが揃うまで待つ（最大 5 秒程度）
    const waitForData = async (timeout = 5000) => {
      const interval = 100
      let waited = 0
      while ((!this.roomId || !this.pin || !this.secret) && waited < timeout) {
        await new Promise(resolve => setTimeout(resolve, interval))
        waited += interval
      }
      return this.roomId && this.pin && this.secret
    }

    const ready = await waitForData()
    if (!ready) {
      alert('ビデオルーム：必要なデータが揃いませんでした。')
      this.$router.replace({ name: 'Home' })
      return
    } else {
      console.log('waitForData OK')
    }

    // WebSocket接続待ち (最大5秒待機)
    const waitForWebSocket = async (timeout = 5000) => {
      const interval = 100
      let waited = 0
      while (this.webSocket.readyState !== WebSocket.OPEN && waited < timeout) {
        await new Promise(resolve => setTimeout(resolve, interval))
        waited += interval
      }
      return this.webSocket.readyState === WebSocket.OPEN
    }

    const socketReady = await waitForWebSocket()
    if (!socketReady) {
      alert('WebSocketが接続されていません。')
      this.$router.replace({ name: 'Home' })
      return
    } else {
      console.log('socketReady OK')
    }
    // WebSocketが接続されていることを確認
    /*
    if (this.webSocket.readyState !== WebSocket.OPEN) {
      alert('WebSocketが接続されていません。')
      this.$router.replace({ name: 'Home' })
      return
    }
      */
    // ここまで変更

    try {
      this.$store.commit('videoCallRoom/setCaller', this.fromUser)
      this.$store.commit(
        'videoCallRoom/setCallerOccupation',
        this.fromOccupation
      )
      this.$store.commit('videoCallRoom/videoActive', this.videoEnable)

      const { roomId, secret, pin } = this
      console.log('roomId=' + roomId + '  secret=' + secret + '  pin=' + pin)

      // 役割をCalleeとして設定
      await this.$store.dispatch('videoCallRoom/setAsCallee', {
        roomId,
        roomSecret: secret,
        pinCode: pin
      })
      console.log('After Callee')

      // WebSocketで通話受け入れメッセージを送信
      this.webSocket.send(WebSocketMessageMode.CALL, {
        type: WebSocketCallMessageTypes.ACCEPTED,
        roomId
      })
      console.log('After webSocket.send')

      // WebRTC接続の確立
      await WebRTCProvider.createConnection(
        this.user.videoApiSecret,
        roomId,
        pin,
        secret,
        this.videoEnable
      )

      this.$store.commit('videoCallRoom/switchCalling', true)
      console.log('通話が開始されました。')
    } catch (error) {
      alert('通話の設定中にエラーが発生しました')
      this.$router.replace({ name: 'Home' })
    }
  }
}
